module.exports = __webpack_public_path__ + "img/card-order-detail-tel-ico.3a7df36e.png";